import Popover from './src/main';
import directive from './src/directive';
import Vue from 'vue';

Vue.directive('popover', directive);

/* istanbul ignore next */
Popover.install = function (vm) {
  vm.directive('popover', directive);
  vm.component(Popover.name, Popover);
};
Popover.directive = directive;

export default Popover;



// WEBPACK FOOTER //
// ./~/vue-xpc/src/element-ui/packages/popover/index.js